const assignmentOrderMessages = [
  {
    range: [1, 1],
    message: "You're next. Please be ready in about 7-10 minutes.",
  },
  {
    range: [2, 3],
    message: "You're coming up soon. Please be ready in about 15-20 minutes.",
  },
  {
    range: [4, 6],
    message: `We have you in line to meet with one of our managers for the final part of your interview.
We expect to meet with you in 25-40 minutes. Feel free in the meantime to grab a snack or listen to some music.
We will update you as you get closer. Thank you for your patience.`,
  },
  {
    range: [7, 10],
    message: `We have you in line to meet with one of our managers for the final part of your interview.
We expect to meet with you in 40-60 minutes. Feel free in the meantime to grab a snack or listen to some music.
We will update you as you get closer. Thank you for your patience.`,
  },
];

const fallbackMessage = 'Please be prepared. You will be called shortly.';

export const isAssignmentMessage = (message) => {
  if (!message) return false;
  return assignmentOrderMessages.some(({ message: msg }) => {
    return message.toLowerCase().includes(message.toLowerCase());
  });
};

export const getAssignmentOrderMessage = (order) => {
  const numericOrder = Number(order);
  const matched = assignmentOrderMessages.find(
    ({ range: [min, max] }) => numericOrder >= min && numericOrder <= max
  );
  return matched?.message || fallbackMessage;
};
